// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4512) return "static/chunks/2ea3adbe-1ed55095ccdd2322.js";
	if (chunkId === 4516) return "static/chunks/4516-b20698762c58e030.js";
	if (chunkId === 6789) return "static/chunks/6789-3a51f7d8312db224.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"310":"73572c7687958faf","533":"a4f88ce37303ec90","2383":"59c2684e1db4c468","3542":"bde15291abc5afde","4764":"59c2684e1db4c468","6560":"20c1845d0b32c53f","7126":"38fb90a260f61eda","7310":"0c2c61949c269cd6"}[chunkId] + ".js";
};